import { fileUrl } from "@/lib/api";
export { formatPrice, formatDate, formatDateTime } from "@/lib/format";
export const fileUrlSafe = (u) => (u ? fileUrl(u) : "");
